import React from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const CFAVersionHistoryTableData = ({ data, index, currentPage }) => {
  const navigate = useNavigate();

  return (
    <tr className="table-rows1">
      <td className="table-each-row-data">
        {(currentPage - 1) * 10 + (index + 1)}
      </td>
      <td className="table-each-row-data">{data?.cfa_id}</td>
      <td className="table-each-row-data">{data?.cfa_name}</td>
      <td className="table-each-row-data">{data?.cfa_depot_manager}</td>
      <td className="table-each-row-data">{data?.cfaVersion?.vendor?.name}</td>
      <td className="table-each-row-data">
        {moment(data?.cfaVersion?.updatedAt).format("DD MMM YYYY HH:mm A")}
      </td>
      {data?.status ? (
        <td className="table-each-row-data color-green">
          <span className="fw_600">Active</span>
        </td>
      ) : (
        <td className="table-each-row-data color-danger">
          <span className="fw_600">Inactive</span>
        </td>
      )}
      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() => navigate(`/cfa/version-history-view/${data.id}`)}
          >
            View
          </button>
        </div>
      </td>
    </tr>
  );
};

export default CFAVersionHistoryTableData;
